import { Button } from '@components/ui/button';
import { useScroll } from '@contexts/scroll';
import { useDraggable } from '@dnd-kit/core';
import { cn } from '@lib/ui/cn';
import { ChevronUp, TextSearch } from 'lucide-react';

interface IProps {
  onSearch(): void;
  position: {
    right: string;
    top: string;
  };
}
function OptionsButton({ onSearch, position }: IProps) {
  const { onScrollTo } = useScroll();
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: '1',
  });
  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : {};

  return (
    <div
      className={cn(
        'gradient-background absolute flex touch-none flex-col space-y-3 rounded-full p-2 sm:p-3',
      )}
      onClick={(event) => event.stopPropagation()}
      ref={setNodeRef}
      style={{ ...style, ...position }}
      {...listeners}
      {...attributes}>
      <Button
        className="text-background flex size-12 cursor-pointer flex-col gap-0"
        onClick={() => onScrollTo()}
        size="icon"
        variant="ghost">
        <ChevronUp className="size-7 sm:size-8" strokeWidth={1.5} />
        <span className="text-xs font-light">Subir</span>
      </Button>
      <Button
        className="text-background mb-3 flex size-12 cursor-pointer flex-col gap-0"
        onClick={onSearch}
        size="icon"
        variant="ghost">
        <TextSearch className="size-7 sm:size-8" strokeWidth={1.5} />
        <span className="text-xs font-light">Buscar</span>
      </Button>
    </div>
  );
}

export default OptionsButton;
